<template>
  <div class="formgrid grid align-items-center vertical-container">
    <div class="col-1">
      <label class="ml-1">Выберите тип объекта:</label>
    </div>
    <div class="col-2">
      <MultiSelect v-model="facilityType" :options="facilityTypes" optionLabel="facility_type_sname"
        optionValue="facility_type_id" placeholder="Тип объекта" appendTo="body">
        <template #option="slotProps">
          <div :data-testid="`facility_type-item:${slotProps.option.facility_type_name}`">
            {{ slotProps.option.facility_type_name }}
          </div>
        </template>
      </MultiSelect>
    </div>
  </div>
  <router-view :facilityType="facilityType" :facilityTypes="facilityTypes" />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

const store = useStore();
const router = useRouter();
const route = useRoute();

const facilityTypes = ref(null);
const facilityType = ref(null);
const facilityTypeService = store.getters.nameToService(
  'BaseService',
  store.getters.info.login,
  store.getters.password,
  'facility_type',
  'ref'
);

onMounted(() => {
  if (!route.params.facility_id && !route.params.node_type_id && !route.params.facility_type_id) {
    router.push({
      name: 'facility-map-child',
      params: { node_type_id: 0, facility_id: 0, facility_type_id: 0 }
    });
  }

  facilityTypeService
    .getData()
    .then((data) => {
      facilityTypes.value = data;
      // если нужен дополнительный фильтр, можно вызвать здесь
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er: er?.response ?? er,
        source: ['FacilityMap', 'mounted'],
      });
    });
});
</script>